import React, { useState } from 'react';
import { AlertTriangle, Plus } from 'lucide-react';
import IssueScanner from './IssueScanner';
import { useAuth } from '../contexts/AuthContext';

interface IssueReportButtonProps {
  variant?: 'fixed' | 'inline';
  size?: 'sm' | 'md' | 'lg';
}

export default function IssueReportButton({ 
  variant = 'inline', 
  size = 'md' 
}: IssueReportButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { profile, updateProfile } = useAuth();

  const handleSuccess = async (points: number) => {
    // Update user profile with earned points
    if (profile) {
      try {
        await updateProfile({
          eco_coins: profile.eco_coins + points,
          points: (profile.points || 0) + points
        });
      } catch (error) {
        console.error('Error updating profile with points:', error);
      }
    }
  };

  const getButtonSize = () => {
    switch (size) {
      case 'sm': return 'px-3 py-1.5 text-sm';
      case 'lg': return 'px-6 py-3 text-lg';
      default: return 'px-4 py-2';
    }
  };

  if (variant === 'fixed') {
    return (
      <>
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-24 right-6 z-10 bg-red-500 hover:bg-red-600 text-white rounded-full p-4 shadow-lg transition-colors"
          aria-label="Report Environmental Issue"
        >
          <div className="relative">
            <AlertTriangle className="h-6 w-6" />
            <span className="absolute -top-1 -right-1 flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
            </span>
          </div>
        </button>
        
        {isOpen && (
          <IssueScanner 
            onClose={() => setIsOpen(false)} 
            onSuccess={handleSuccess}
          />
        )}
      </>
    );
  }

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className={`bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors flex items-center space-x-2 ${getButtonSize()}`}
      >
        <Plus className="h-5 w-5" />
        <span>Report Environmental Issue</span>
      </button>
      
      {isOpen && (
        <IssueScanner 
          onClose={() => setIsOpen(false)} 
          onSuccess={handleSuccess}
        />
      )}
    </>
  );
}